import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { compose, branch, withProps, mapProps, setDisplayName } from 'recompose';
import { styled } from '@rexlabs/styling';
import { defer } from './behaviour';
import meta from './text-input-meta';
import styles from './text-input-styles';
import { TextInputInternal } from './text-input';
var assign = _Object$assign;

var TextAreaInput = function TextAreaInput(_ref) {
  var styles = _ref.styles,
      type = _ref.type,
      setRef = _ref.setRef,
      props = _objectWithoutProperties(_ref, ["styles", "type", "setRef"]);

  return React.createElement("div", styles('containerTextArea'), React.createElement("pre", styles('input', 'inputTextAreaMirror'), (props.value || props.defaultValue || '') + '\n\n'), React.createElement("textarea", _extends({}, props, styles('input', 'inputTextArea'), {
    ref: setRef
  })));
};

var AutoSizedTextArea = compose(setDisplayName('AutoSizedTextArea'), withProps({
  Input: TextAreaInput
}));
var ManualSizedTextArea = compose(setDisplayName('ManualSizedTextArea'), withProps({
  Input: 'textarea'
}));
var sanitizeProps = mapProps(function (_ref2) {
  var cosmetic = _ref2.cosmetic,
      props = _objectWithoutProperties(_ref2, ["cosmetic"]);

  return props;
});
var asTextArea = compose(setDisplayName('behaviour(AsTextArea)'), sanitizeProps, branch(function (_ref3) {
  var value = _ref3.value;
  return value !== undefined;
}, AutoSizedTextArea, ManualSizedTextArea));
var TextArea = defer(asTextArea)(TextInputInternal);
assign(TextArea, _objectSpread({}, meta, {
  displayName: 'TextArea'
}));
export default styled(styles)(TextArea);